import { actions as toastrActions } from 'react-redux-toastr';

const commonOptions = {
  removeOnHover: true,
  timeOut: 3000,
};

export const infoNotification = (message, options) => toastrActions.add({
  type: 'info',
  message,
  options: {
    ...commonOptions,
    ...options,
  },
});

export const successNotification = (message, options) => toastrActions.add({
  type: 'success',
  message,
  options: {
    ...commonOptions,
    ...options,
  },
});

export const errorNotification = (message, options) => toastrActions.add({
  type: 'error',
  message,
  options: {
    ...commonOptions,
    ...options,
  },
});

export const warningNotification = (message, options) => toastrActions.add({
  type: 'warning',
  message,
  options: {
    ...commonOptions,
    ...options,
  },
});
